import React, { useState } from 'react';
import { registerUser } from '../api/userApi';
import { useUser } from '../context/UserContext';
import '../styles.css';
import imageSchool from '../Images/Photo1.PNG';
import { useNavigate } from 'react-router-dom';

const Register = ({ setAuth }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const { setUserId } = useUser();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    try {
      const response = await registerUser({ username, email, password });

      if (response.data) {
        alert('Un email de vérification a été envoyé. Vérifiez votre boîte mail.');
        navigate('/check-email');
      } else {
        setError('Erreur lors de l\'inscription.');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        setError(
          typeof data === 'string'
            ? data
            : data.message || data.error || 'Erreur serveur'
        );
      } else {
        setError('Erreur lors de l\'inscription.');
      }
    }
  };

  return (
    <div className="register-page">
      <div className="register-shell">
        <div className="register-brand-panel">
          <div className="brand-badge">AL-BAWSALA</div>

          <img
            className="brand-image"
            src={imageSchool}
            alt="Illustration inscription"
          />

          <h1>Bienvenue dans votre espace privé.</h1>

          <p className="arabic-text">
            البوصلة هي منصة رقمية موجهة لمستشاري التوجيه التربوي. هي بمثابة لوحة قيادة
            للمساعدة على تنظيم، تبسيط وأرشفة المهام المنجزة على شكل تقارير يومية
            (بطاقات تقنية) شهرية أو دورية.
          </p>

          <p className="arabic-text muted">
            سنعمل على تطوير البوصلة ليصبح بمقدورها مساعدتك على تدبير مجالس الأقسام في نهاية
            السنة الدراسية وتقديم جميع الإحصائيات والمذكرات المطلوبة.
          </p>
        </div>

        <div className="register-form-panel">
          <div className="auth-card register-card">
            <div className="auth-card-header">
              <span className="header-kicker">Créer un compte</span>
              <h2>Inscription</h2>
            </div>

            <div className="auth-card-body">
              <h3>Bienvenue</h3>
              <p>Inscrivez-vous pour accéder à toutes les fonctionnalités.</p>

              {error && <div className="status-alert error">{error}</div>}

              <form onSubmit={handleRegister} className="login-form">
                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="username"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Nom d'utilisateur"
                    required
                  />
                  <label htmlFor="username">Nom d'utilisateur</label>
                </div>

                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="floatingInput"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@example.com"
                    required
                  />
                  <label htmlFor="floatingInput">Email</label>
                </div>

                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="floatingPassword"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mot de passe"
                    required
                  />
                  <label htmlFor="floatingPassword">Mot de passe</label>
                </div>

                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirmer le mot de passe"
                    required
                  />
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                </div>

                <button className="btn btn-primary login-button" type="submit">
                  Créer un compte
                </button>
              </form>
            </div>

            <div className="auth-card-footer">
              <span>Vous avez déjà un compte ?</span>
              <button
                onClick={() => navigate('/login')}
                className="btn btn-link signup-link"
              >
                Connexion
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
